import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const SelectedUrl = styled.div`
  color: ${({ theme }) => theme.palette.BR300};
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: flex-end;
    margin-top: 12px;
    font-size: 16px;
  }
`;
export const FilterTbWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Label = styled.h3`
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: ${({ theme }) => theme.palette.coral};
  margin-bottom: 20px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-weight: 900;
    font-size: 30px;
    line-height: 38px;
  }
`;

export const ItemWrapper = styled.div`
  max-width: 100vw;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1240px;
    .swiper-slide {
      margin-right: 13px !important;
      max-width: 300px !important;
      width: 100%;
    }
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  padding: 8px;
  border-radius: 8px;
  gap: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 12px;
  }
`;
export const LinkContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL0};
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;
